"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "14.71 7.34 14.71 13.87 15.96 13.87 16.09 13.64 16.09 7.34 14.71 7.34",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.35,7.25a3,3,0,0,0-2.3.86,3.48,3.48,0,0,0-.81,2.48,3.57,3.57,0,0,0,.8,2.5,3,3,0,0,0,2.31.87,3,3,0,0,0,2.3-.87,3.56,3.56,0,0,0,.8-2.49,3.56,3.56,0,0,0-.8-2.49A3,3,0,0,0,10.35,7.25Zm0,5.55a1.43,1.43,0,0,1-1.24-.55,2.71,2.71,0,0,1-.42-1.65A2.73,2.73,0,0,1,9.11,9a1.45,1.45,0,0,1,1.24-.55c1.1,0,1.65.73,1.65,2.2S11.45,12.8,10.35,12.8Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.85,7.86a2.76,2.76,0,0,0-1.8-.52H2v6.53H3.35V11.55h.59A2.82,2.82,0,0,0,5.81,11a2,2,0,0,0,.66-1.61A1.85,1.85,0,0,0,5.85,7.86Zm-1.09,2.3a1.53,1.53,0,0,1-1,.25H3.35V8.48H4a1.28,1.28,0,0,1,.83.23.92.92,0,0,1,.26.72A.88.88,0,0,1,4.76,10.16Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.35,8.4A1.45,1.45,0,0,0,9.11,9a2.73,2.73,0,0,0-.42,1.65,2.71,2.71,0,0,0,.42,1.65,1.43,1.43,0,0,0,1.24.55c1.1,0,1.65-.73,1.65-2.2S11.45,8.4,10.35,8.4Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.81,8.71A1.28,1.28,0,0,0,4,8.48H3.35v1.93H3.8a1.53,1.53,0,0,0,1-.25.88.88,0,0,0,.31-.73A.92.92,0,0,0,4.81,8.71Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16,13.87H14.71V7.34h1.38v6.3l.69-1.21h0a1.86,1.86,0,0,1,1.32-.9V2.1a.48.48,0,0,0-.55-.55H.55A.48.48,0,0,0,0,2.1v17a.48.48,0,0,0,.55.55H6.12L8.91,22.4a.22.22,0,0,0,.14.05.2.2,0,0,0,.14-.05L12,19.65h.56l3-5.12ZM5.81,11a2.82,2.82,0,0,1-1.87.56H3.35v2.32H2V7.34H4.05a2.76,2.76,0,0,1,1.8.52,1.85,1.85,0,0,1,.62,1.52A2,2,0,0,1,5.81,11Zm6.84,2.1a3,3,0,0,1-2.3.87A3,3,0,0,1,8,13.09a3.57,3.57,0,0,1-.8-2.5,3.48,3.48,0,0,1,.81-2.48,3,3,0,0,1,2.3-.86,3,3,0,0,1,2.3.86,3.56,3.56,0,0,1,.8,2.49A3.56,3.56,0,0,1,12.65,13.09Z",
    fill: "#004864"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.94,21.9l-4-6.61-1.24-2.13a.39.39,0,0,0-.31-.17.35.35,0,0,0-.31.18l-1.21,2.11-3.1,5.25L12.88,22a.33.33,0,0,0,0,.36.32.32,0,0,0,.31.14H23.64a.36.36,0,0,0,.32-.18A.38.38,0,0,0,23.94,21.9Zm-6.09-6a.59.59,0,0,1,1.17,0v2.9a.59.59,0,0,1-1.17,0Zm.58,5.76a.69.69,0,1,1,.69-.69A.69.69,0,0,1,18.43,21.65Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;